import './BlockCarouselImages.scss';
class BlockCarouselImages {
    constructor( node ) {
        this.node = node;
        this.carouselInterval = null;
        this.carouselIndex = 0;
    }
    init() {
        let t = this;
        let carousel = t.node.querySelector('.wrapper__content');
        let carouselItems = carousel.querySelectorAll('.content__element');
        let buttonNext = t.node.querySelector('.BlockCarouselImages__button');
        let controlBtn = t.node.querySelectorAll('.control__button');

        controlBtn.forEach( ( btn, index ) => {
            btn.addEventListener('click', () => {
                carousel.scrollTo({ 
                    top: 0, 
                    left: carousel.offsetWidth * parseInt( btn.getAttribute('data-index') ),
                    behavior: 'smooth' 
                });
            });
        });

        buttonNext.addEventListener('click', () => {
            if( t.carouselIndex == ( carouselItems.length - 1 ) ) {
                t.carouselIndex = 0;
            } else {
                t.carouselIndex = t.carouselIndex + 1;
            }
            carousel.scrollTo({ 
                top: 0, 
                left: carousel.offsetWidth * t.carouselIndex,
                behavior: 'smooth' 
            });
        });

        // -- slide into wrapper -- //
            let observer = new IntersectionObserver(
                ( entries, settings )  => {
                    entries.forEach( ( entry, index ) => {
                        if( entry.isIntersecting ) {
                            t.carouselIndex = parseInt( entry.target.getAttribute('data-index') );
                            entry.target.setAttribute('aria-hidden','false');
                            t.setCarouselIndex();
                        } else {
                            entry.target.setAttribute('aria-hidden','true');
                        }
                    });
                },
                {
                    threshold: 0.5,
                    root : carousel,
                }
            );
            carouselItems.forEach( ( item, index ) => {
                observer.observe( item );
            });
        // -- END -- //

        // -- horizontal image load -- //
            let observerLoad = new IntersectionObserver(
                ( entries, settings ) => {
                    entries.forEach( ( entry, index ) => {
                        if( entry.isIntersecting ) {
                            window.theme.lazyObj.loadSingleImage( entry.target.querySelector('.LazyAsset__item') );
                            observerLoad.unobserve( entry.target );
                        }
                    });
                },
                {
                    threshold: 0,
                    root : carousel,
                    rootMargin: '0px 200px',
                }
            );
            carouselItems.forEach( ( item, index ) => {
                observerLoad.observe( item );
            });
        // -- END -- //

        // -- autoplay -- //
            t.carouselLoop();
            let autoplayBtn = t.node.querySelector('.BlockCarouselImages__autoplay')
            autoplayBtn.addEventListener('click', ( ev ) => {
                if( autoplayBtn.getAttribute('aria-pressed') == 'true' ) {
                    clearInterval( t.carouselInterval );
                    t.carouselInterval = null;
                    autoplayBtn.setAttribute('aria-pressed', 'false');
                } else {
                    t.carouselLoop();
                    autoplayBtn.setAttribute('aria-pressed', 'true');
                }
            });
            t.node.addEventListener( 'mouseenter', () => {
                clearInterval( t.carouselInterval );
                t.carouselInterval = null;
                autoplayBtn.setAttribute('aria-pressed', 'false');
            });
            t.node.addEventListener( 'mouseleave', () => {
                t.carouselLoop();
                autoplayBtn.setAttribute('aria-pressed', 'true');
            });
        // -- END -- //


    }
    carouselLoop() {
        let t = this;
        let carouselWrapper = t.node.querySelector('.wrapper__content');
        let carouselItems = carouselWrapper.querySelectorAll('.content__element');
        clearInterval( t.carouselInterval );
        t.carouselInterval = setInterval( () => {
            
            if( t.carouselIndex == ( carouselItems.length - 1 ) ) {
                t.carouselIndex = 0;
            } else {
                t.carouselIndex = t.carouselIndex + 1;
            }
            carouselWrapper.scrollTo({ 
                top: 0, 
                left: carouselWrapper.offsetWidth * t.carouselIndex,
                behavior: 'smooth' 
            });

        }, 2500 );
    }
    setCarouselIndex() {
        let t = this;
        t.node.querySelectorAll('.control__button').forEach( ( btn, index ) => {
            if( t.carouselIndex == index ) {
                btn.setAttribute('aria-current','true');
            } else {
                btn.removeAttribute('aria-current');
            }
        });
    }
}
JSModules['BlockCarouselImages'] = BlockCarouselImages;
export default BlockCarouselImages;